import React from "react";
import {
  FaRobot,
  FaLink,
  FaMobileAlt,
  FaCode,
  FaLaptopCode,
  FaSyncAlt,
  FaBullhorn,
  FaChartLine,
  FaShoppingCart,
  FaCheckCircle,
  FaExchangeAlt,
  FaCoins,
} from "react-icons/fa";

const services = [
  {
    icon: <FaRobot />,
    title: "AI Solutions & Automation",
    desc: "Build intelligent systems that automate operations, improve decision-making, and scale your business.",
    points: [
      "AI Agents & Chatbots",
      "Workflow Automation",
      "Predictive Analytics",
      "NLP & Computer Vision",
      "Generative AI Integrations",
    ],
  },
  {
    icon: <FaLink />,
    title: "Blockchain Development",
    desc: "Secure, scalable blockchain solutions for modern digital ecosystems.",
    points: [
      "Smart Contracts",
      "DeFi Platforms",
      "NFT Marketplaces",
      "Crypto Exchanges",
    ],
  },
  {
    icon: <FaExchangeAlt />,
    title: "Crypto Exchange Development",
    desc: "We provide high-performance exchange solutions as a reliable crypto exchange development company in India.",
    points: [
      "Centralized Exchange (CEX)",
      "Decentralized Exchange (DEX)",
      "Crypto Wallet Integration",
      "Trading Engine & Liquidity Solutions",
    ],
  },
  {
    icon: <FaCoins />,
    title: "Token Development Services",
    desc: "Launch secure and scalable digital assets with an experienced token development company in India.",
    points: [
      "ERC20 Token Development",
      "BEP20 Token Development",
      "Stablecoin Development",
      "Smart Contract Integration",
    ],
  },
  {
    icon: <FaMobileAlt />,
    title: "Mobile App Development",
    desc: "High-performance mobile apps designed for seamless user experience.",
    points: ["iOS & Android Apps", "React Native & Flutter", "IoT & Wearables"],
  },
  {
    icon: <FaCode />,
    title: "Web Development",
    desc: "Scalable web apps with modern technologies.",
    points: ["SaaS Platforms", "Enterprise Portals", "PWAs", "Custom CMS"],
  },
  {
    icon: <FaLaptopCode />,
    title: "Custom Software",
    desc: "Tailored systems for business efficiency.",
    points: ["CRM & ERP", "Automation Tools", "Business Systems"],
  },
  {
    icon: <FaSyncAlt />,
    title: "Digital Transformation",
    desc: "Upgrade your infrastructure and workflows.",
    points: ["Cloud Migration", "Legacy Modernization", "Automation"],
  },
  {
    icon: <FaChartLine />,
    title: "Data Science & Analytics",
    desc: "Turn data into actionable insights.",
    points: ["BI Dashboards", "Predictive Models", "Big Data"],
  },
  {
    icon: <FaShoppingCart />,
    title: "E-commerce Development",
    desc: "Build scalable online stores.",
    points: ["Custom Stores", "Payments", "Inventory"],
  },
  {
    icon: <FaBullhorn />,
    title: "Digital Marketing",
    desc: "Scale your reach and conversions.",
    points: ["SEO", "Paid Ads", "Social Media"],
  },
];

function Transforming() {
  return (
    <section className="xeer-services">
      <div className="container">
        {/* HEADER */}
        <div className="header text-center">
          <h4 className="sub-title">Our Expertise </h4>
          <h2>Solutions That Power Your Growth</h2>
          <p>
            At Xeer Technology — Blockchain & AI Builders, we combine deep
            technical expertise with real-world execution to deliver scalable
            digital solutions for startups, enterprises, and growing businesses
            worldwide.
          </p>
          <p>
            As a leading blockchain development company in India, we specialize
            in blockchain, crypto exchange, token development, AI automation,
            and enterprise software solutions built for performance, security,
            and long-term scalability.
          </p>
          <span>One Team. End-to-End Execution. Built to Scale.</span>
        </div>

        {/* GRID */}
        <div className="services-grid-one">
          {services.map((item, i) => (
            <div className="service-card" key={i}>
              <div className="card-inner">
                <div className="icon-box">{item.icon}</div>

                <h3>{item.title}</h3>
                <p className="desc">{item.desc}</p>

                <ul>
                  {item.points.map((p, idx) => (
                    <li key={idx}>
                      <FaCheckCircle />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* CLOSING */}
        <div className="closing">
          From idea to execution — we build digital products that scale,
          perform, and drive real business growth.
        </div>
      </div>
    </section>
  );
}

export default Transforming;
